import gql from 'graphql-tag'
import { gqlast } from '../graphqlParser'

/* Función para que el usuario de organización actualice su información */
const UPDATE_USER = (user) => {
    const updatedUser = {
        id: user.id,
        profilePicture: user.profilePicture,
        imgBackground: user.imgBackground,
        password: user.password,
        token: user.token
    }

    const omitTypename = (key, value) => (key === '__typename' ? undefined : value)
    const newPayload = JSON.parse(JSON.stringify(updatedUser), omitTypename)

    const newMutation = gqlast`mutation {
        updateUser(data:${newPayload}) {
           id
           name
        }
    }`
    return gql`${newMutation}`
}

/* Función para que el administrador actualice la información de un usuario de organización */
const UPDATE_ORGANIZATON = (user) => {
    const userData = {
        id: user.id,
        name: user.name,
        lastName: user.lastName,
        email: user.email,
        rfc: user.rfc,
        razonSocial: user.razonSocial,
        bank: user.bank,
        clabe: user.clabe,
        billEmail: user.billEmail,
        tel: user.tel,
        companyName: user.companyName,
        role: user.role,
        validationStatus: user.validationStatus
    }

    const newMutation = gqlast`mutation {
        updateUserData(data:${userData}) {
           id
           companyName
           name
           lastName
        }
    }`
    return gql`${newMutation}`
}

/* Función para que organizador actualice sus datos bancarios (SE SOLICITAN ESOS DATOS AL MOMENTO DE CREAR EL PRIMER EVENTO/AFILIACIÓN) */
const UPDATE_BANK_DATA = (user) => {
    const userData = {
        rfc: user.rfc?user.rfc:"",
        razonSocial: user.razonSocial?user.razonSocial:"",
        bank: user.bank?user.bank:"",
        clabe: user.clabe?user.clabe:"",
        billEmail: user.billEmail?user.billEmail:""
    }

    const newMutation = gqlast`mutation {
        updateUserData(data:${userData}) {
           id
           companyName
           name
           lastName
           validationStatus
        }
    }`
    return gql`${newMutation}`
}

/* Función para crear usuario de tipo organizador WeChamber */
const CREATE_ORGANIZER = (organizer) => {
    const newOrganizer = {
        name: organizer.name,
        lastName: organizer.lastName,
        email: organizer.email,
        password: organizer.password,
        companyName: organizer.companyName,
        rfc: organizer.rfc,
        tel: organizer.tel,
        profilePicture: organizer.profilePicture ? organizer.profilePicture : "https://v2.wechamber.mx/api/files/usuario1/download/wechamberAvatr.png"
    }

    const newMutation = gqlast`mutation {
        createOrganizer(data:${newOrganizer}) {
            user {
                id
                name
                lastName
                companyName
                profilePicture
                role
                email
                validationStatus
            }
            token
        }
    }`

    return gql`${newMutation}`
}

/* Función para crear usuario de tipo organizador LITE */
const CREATE_LITE_ORGANIZER = (organizer) => {
    const newOrganizer = {
        name: organizer.name,
        lastName: organizer.lastName,
        email: organizer.email,
        password: organizer.password,
        companyName: organizer.companyName,
        tel: organizer.tel,
        profilePicture: organizer.profilePicture ? organizer.profilePicture : "https://v2.wechamber.mx/api/files/usuario1/download/wechamberAvatr.png"
    }

    const newMutation = gqlast`mutation {
        createLiteOrganizer(data:${newOrganizer}) {
            user {
                id
                name
                lastName
                companyName
                profilePicture
                role
                email
                validationStatus
            }
            token
        }
    }`

    return gql`${newMutation}`
}

/* Función para crear usuario de tipo afiliado */
const CREATE_ATTENDEE = (attendee) => {
    const newAttendee = {
        name: attendee.name,
        lastName: attendee.lastName,
        email: attendee.email,
        password: attendee.password,
        companyName: attendee.companyName,
        rfc: attendee.rfc,
        tel: attendee.tel
    }

    const newMutation = gqlast`mutation {
        createAttendee(data:${newAttendee}) {
            user {
                id
                name
                lastName
                companyName
                profilePicture
                role
                email
                validationStatus
            }
            token
        }
    }`

    return gql`${newMutation}`
}

/* Función para iniciar sesión */
const LOGIN = (data) => {
    const newMutation = gqlast`mutation {
        login(data:${data}) {
            user {
                id
                name
                lastName
                companyName
                profilePicture
                role
                email
                tel
                rfc
                imgBackground
                validationStatus
                surveyModule
            }
            token
        }
    }`

    return gql`${newMutation}`
}

/* Función para obtener datos de usuario al momento de iniciar sesión */
const FETCH_DATA_USER = (email) => {
    const newMutation = gqlast`mutation {
        fetchDataUser(email:${email}) {
            id
            name
            lastName
            email
            token
        }
    }`

    return gql`${newMutation}`
}

export { CREATE_ORGANIZER, CREATE_LITE_ORGANIZER, CREATE_ATTENDEE, LOGIN, UPDATE_USER, UPDATE_ORGANIZATON, UPDATE_BANK_DATA, FETCH_DATA_USER }